import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Aux } from './Common';

export const CardContainer = ({ lg, md, sm, xs, className, children }) => {
	return (
		<Aux className={`content-inner ${className || ""}`}>
			<Row>
				<Col lg={lg || 9} md={md || 9} sm={sm || 12} xs={xs || 12} className="col-centered">
					{children}
				</Col>
			</Row>
		</Aux >
	);
}